export default __webpack_public_path__ + "static/media/1.6d994d7f.png";